/****************************************************
 * Module Name:  department.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class DepartmentProxy {
  static GetAllDepartment = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/department",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllDepartmentDetail = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/department/detail",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllDepartmentDetailMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/department/detail/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleDepartment = (departmentId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/department/${departmentId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleDepartmentIdUser = (departmentId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/department/user/${departmentId}/detail`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleDepartmentUsers = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/kapancreation/department/users`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckDepartmentAvailable = (department, callback) => {
    let params = {
      department: department,
    };

    restAPICall(
      Constants.MANAGER_URL + "/department/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddDepartment = (department, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/department/detail/create",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(department),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateDepartment = (department, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/department/recreate",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(department),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ValidateDepartmentHead = (id, callback) => {
    let params = {
      id: id
    }

    restAPICall(Constants.MANAGER_URL + '/user/validatehead', 'get', Constants.userToken, params, undefined, undefined, 0)
      .then(response => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }
}
